import { render, staticRenderFns } from "./noNeedToMaintainTheProduct.vue?vue&type=template&id=54769ac5&scoped=true&"
import script from "./noNeedToMaintainTheProduct.vue?vue&type=script&lang=js&"
export * from "./noNeedToMaintainTheProduct.vue?vue&type=script&lang=js&"
import style0 from "./noNeedToMaintainTheProduct.vue?vue&type=style&index=0&id=54769ac5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54769ac5",
  null
  
)

export default component.exports